module.exports = __webpack_public_path__ + "static/transaction_fee_management1@3x-8d41837a8edc39630cc446f67664b463.png";